// The new-password rule as every screen that sets one says it (DIRECTION A27):
// sign-up, a reset, a change and an email change's undo. The rule itself is
// the domain's (`NewPassword`, `newPasswordProblem`), and the server refuses by
// it in the same words; a screen says it first so nobody waits on a round trip
// to hear it.

import { newPasswordProblem, PASSWORD_MIN_LENGTH } from '@fsp/domain';

/** Under the field, before anything is typed. */
export const PASSWORD_RULE = `${PASSWORD_MIN_LENGTH} characters or more, and not a common one like password1.`;

/** Why a new password would be refused, or null. */
export function newPasswordRefusal(password: string, email?: string | null): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Passwords are ${PASSWORD_MIN_LENGTH} characters or more.`;
  }
  return newPasswordProblem(password, email);
}
